import dayjs from "dayjs";

// date and date-time formats in dayjs
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";

export function dateFormat(date?: string | Date) {
  return date ? dayjs(date).format(DATE_FORMAT) : "-";
}

export function dateTimeFormat(date?: string | Date): string | JSX.Element {
  return date ? dayjs(date).format(DATE_TIME_FORMAT) : "-";
}
